export default {
    PRODWS_URL: process.env.REACT_APP_PRODWS_AFREESPACE_URL || "https://prodws.afreespace.com",
    ACCOUNTWS_URL: process.env.REACT_APP_ACCOUNTWS_AFREESPACE_URL || "https://accountws.afreespace.com",
    LOGIN_BASE_URL: process.env.REACT_APP_LOGIN_BASE_URL || "https://login.afreespace.com",
    DEBUG_PAGE_URL: process.env.REACT_APP_DEBUG_PAGE_URL || "https://tools.afreespace.com",
    SPOT_BASE_URL: process.env.REACT_APP_SPOT_BASE_URL || "https://spotws.afreespace.com",
    ANALYTICS_BASE_URL: process.env.REACT_APP_ANALYTICS_BASE_URL || "https://analytics.afreespace.com",
}
